import api from '../utils/request'

export default {
  // 列表 + 组合查询：device_name / department / report_date_start / report_date_end
  list(params) {
    return api.get('/pdf-reminder/', { params })
  },
  // 列表顶部汇总：已过期 / 30 天内到期 / 合计（跟随当前筛选条件，不分页）
  stats(params) {
    return api.get('/pdf-reminder/stats/', { params })
  },
  // 新增（含最多 2 个 PDF，FormData）
  create(data) {
    return api.post('/pdf-reminder/', data)
  },
  // 编辑（含可选 PDF 替换，FormData）
  update(id, data) {
    return api.put(`/pdf-reminder/${id}/`, data)
  },
  // 删除
  delete(id) {
    return api.delete(`/pdf-reminder/${id}/`)
  },
  // 即将到期 / 已到期记录：days 参数（默认 30）
  overdue(params) {
    return api.get('/pdf-reminder/overdue/', { params })
  },
}
